import { Component, input, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { inject } from '@angular/core';

@Component({
	selector: 'app-mica-chat-mensaje-imagen',
	templateUrl: './mica-chat-mensaje-imagen.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './mica-chat-mensaje-imagen.css',
})
export class MicaChatMensajeImagen {
	private sanitizer = inject(DomSanitizer);

	streamUrl = input.required<string | null>();
	caption = input<string>('');

	enlarge = signal(false);

	safeUrl = computed(() => {
		const url = this.streamUrl();
		if (!url) return null;
		return this.sanitizer.bypassSecurityTrustUrl(url);
	});
}
